var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAiClearHistory = function SvgAiClearHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 2h4a1 1 0 0 1 1 1H6a1 1 0 0 1 1-1zM3 5h12v1H3V5zm1 2h10l-.8 8H4.8L4 7zm2 1.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0zm3 0v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0zm3 0v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0z"
  })));
};
export default SvgAiClearHistory;